"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculationType = void 0;
exports.CalculationType = {
    CountEmpty: "COUNT_EMPTY",
    CountNonEmpty: "COUNT_NON_EMPTY",
    PercentEmpty: "PERCENT_EMPTY",
    PercentNonEmpty: "PERCENT_NON_EMPTY",
    CountChanged: "COUNT_CHANGED",
    PercentChanged: "PERCENT_CHANGED",
    Sum: "SUM",
    Average: "AVERAGE",
    Min: "MIN",
    Max: "MAX",
};
